'use client'
import * as Icon from "@phosphor-icons/react/dist/ssr";
import React, { useState } from "react";
import { useTranslations } from "next-intl";
import { Link } from "@/navigation";

const BlogSearch = () => {
	const t = useTranslations()
	const [searchTitle, setSearchTitle] = useState("")

	return (
		<div className="overflow-hidden border border-gray-200 bg-white shadow-md">
			<div className="bg-mainColor px-5 py-3">
				<h2 className="text-lg font-bold text-white flex items-center gap-2">
					<i className="ri-search-line text-lg"></i>
					{t('base.Search')}
				</h2>
			</div>
			<div className="p-4">
			<div className='relative w-full h-12'>
				<input 
					className='py-2 px-4 pr-12 w-full h-full border border-gray-200 bg-white rounded-lg focus:border-mainColor focus:ring-1 focus:ring-mainColor outline-none transition-all duration-200' 
					type="text"   
					value={searchTitle}
					placeholder={t('base.Search')} 
					onChange={e => setSearchTitle(e.target.value)} 
				/>
				<Link href={searchTitle ? `/blog?search=${encodeURIComponent(searchTitle)}` : '/blog'}>
					<Icon.MagnifyingGlass
						className='w-5 h-5 text-gray-400 hover:text-mainColor duration-300 absolute top-1/2 -translate-y-1/2 right-4 cursor-pointer' />
				</Link>
			</div>
			</div>
		</div>
	)
}
export default   React.memo(BlogSearch)
